import CTNButton from '@ctn/ui/components/ctn-button';
import { type ReactElement } from 'react';

import { useDirtyForm } from '@/context/dirtyForm.context';
import { useEmpresa } from '@/context/empresa.context';

const BotonesFooter = (): ReactElement => {
	const { send, setIsEdit, emisor, errorCP, errorEmail, isLoading } = useEmpresa();
	const { isDirtyForm, checkDirtyForm, setIsDirtyForm } = useDirtyForm();	

	const handleOnCancel = () => {
		if (isDirtyForm) {
			checkDirtyForm({
				action() {
					setIsDirtyForm(false);
					setIsEdit(false);
				},
			});
		} else {			
			setIsEdit(false);
		}
	};

	const isSaveDisabled = (): boolean => {
		if (!emisor?.direccion) return false;
		const { direccion } = emisor;

		return (
			!direccion.codTipoVia ||
			!direccion.nombreVia ||
			!direccion.numeroVia ||
			!direccion.codigoPostal ||
			!direccion.codigoProvincia ||
			!direccion.codigoMunicipio ||
			!emisor.telefono ||
			!emisor.email ||
			!isDirtyForm ||
			Boolean(errorCP) ||
			Boolean(errorEmail) ||
			isLoading
		);
	};

	return (
		<div className="c-pnp-company__buttons-footer">
			<CTNButton mode="tertiary" label="Cancelar" size="size-40" onClick={handleOnCancel} />
			<CTNButton
				mode="primary"
				disabled={isSaveDisabled()}
				label="Guardar cambios"
				size="size-40"
				onClick={send}
			/>
		</div>
	);
};

export default BotonesFooter;
